/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  EmailTemplateApiResource,
  EmailTemplateClonePartialRequest,
  EmailTemplateCloneRequest,
  EmailTemplateCustomPreviewRequest,
  EmailTemplateEditPartialRequest,
  EmailTemplateRequest,
  GetApiEmailTemplateHelpers200,
  GetApiEmailTemplateList200,
  GetApiEmailTemplateListParams,
  GetApiEmailTemplatePartialSchemaList200,
  GetApiEmailTemplatePreview200,
  GetApiEmailTemplateSchemaList200,
  NotFoundErrorResponse,
  PostApiEmailTemplateCustomPreview200,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiEmailTemplateHelpersResponse200 = {
  data: GetApiEmailTemplateHelpers200
  status: 200
}

export type getApiEmailTemplateHelpersResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiEmailTemplateHelpersResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiEmailTemplateHelpersResponseSuccess = (getApiEmailTemplateHelpersResponse200) & {
  headers: Headers;
};
export type getApiEmailTemplateHelpersResponseError = (getApiEmailTemplateHelpersResponse401 | getApiEmailTemplateHelpersResponse403) & {
  headers: Headers;
};

export type getApiEmailTemplateHelpersResponse = (getApiEmailTemplateHelpersResponseSuccess | getApiEmailTemplateHelpersResponseError)

export const getGetApiEmailTemplateHelpersUrl = () => {


  

  return `/api/email-templates/schemas/helpers`
}

export const getApiEmailTemplateHelpers = async ( options?: RequestInit): Promise<getApiEmailTemplateHelpersResponse> => {
  
  return customFetch<getApiEmailTemplateHelpersResponse>(getGetApiEmailTemplateHelpersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiEmailTemplateListResponse200 = {
  data: GetApiEmailTemplateList200
  status: 200
}

export type getApiEmailTemplateListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiEmailTemplateListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiEmailTemplateListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiEmailTemplateListResponseSuccess = (getApiEmailTemplateListResponse200) & {
  headers: Headers;
};
export type getApiEmailTemplateListResponseError = (getApiEmailTemplateListResponse400 | getApiEmailTemplateListResponse401 | getApiEmailTemplateListResponse403) & {
  headers: Headers;
};

export type getApiEmailTemplateListResponse = (getApiEmailTemplateListResponseSuccess | getApiEmailTemplateListResponseError)

export const getGetApiEmailTemplateListUrl = (params?: GetApiEmailTemplateListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/email-templates?${stringifiedParams}` : `/api/email-templates`
}

export const getApiEmailTemplateList = async (params?: GetApiEmailTemplateListParams, options?: RequestInit): Promise<getApiEmailTemplateListResponse> => {
  
  return customFetch<getApiEmailTemplateListResponse>(getGetApiEmailTemplateListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiEmailTemplateCloneResponse201 = {
  data: EmailTemplateApiResource
  status: 201
}

export type postApiEmailTemplateCloneResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiEmailTemplateCloneResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiEmailTemplateCloneResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiEmailTemplateCloneResponseSuccess = (postApiEmailTemplateCloneResponse201) & {
  headers: Headers;
};
export type postApiEmailTemplateCloneResponseError = (postApiEmailTemplateCloneResponse400 | postApiEmailTemplateCloneResponse401 | postApiEmailTemplateCloneResponse403) & {
  headers: Headers;
};

export type postApiEmailTemplateCloneResponse = (postApiEmailTemplateCloneResponseSuccess | postApiEmailTemplateCloneResponseError)

export const getPostApiEmailTemplateCloneUrl = () => {


  

  return `/api/email-templates`
}

export const postApiEmailTemplateClone = async (emailTemplateCloneRequest: EmailTemplateCloneRequest, options?: RequestInit): Promise<postApiEmailTemplateCloneResponse> => {
  
  return customFetch<postApiEmailTemplateCloneResponse>(getPostApiEmailTemplateCloneUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailTemplateCloneRequest,)
  }
);}


export type postApiEmailTemplateClonePartialResponse201 = {
  data: EmailTemplateApiResource
  status: 201
}

export type postApiEmailTemplateClonePartialResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiEmailTemplateClonePartialResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiEmailTemplateClonePartialResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiEmailTemplateClonePartialResponseSuccess = (postApiEmailTemplateClonePartialResponse201) & {
  headers: Headers;
};
export type postApiEmailTemplateClonePartialResponseError = (postApiEmailTemplateClonePartialResponse400 | postApiEmailTemplateClonePartialResponse401 | postApiEmailTemplateClonePartialResponse403) & {
  headers: Headers;
};

export type postApiEmailTemplateClonePartialResponse = (postApiEmailTemplateClonePartialResponseSuccess | postApiEmailTemplateClonePartialResponseError)

export const getPostApiEmailTemplateClonePartialUrl = () => {


  

  return `/api/email-templates/partials`
}

export const postApiEmailTemplateClonePartial = async (emailTemplateClonePartialRequest: EmailTemplateClonePartialRequest, options?: RequestInit): Promise<postApiEmailTemplateClonePartialResponse> => {
  
  return customFetch<postApiEmailTemplateClonePartialResponse>(getPostApiEmailTemplateClonePartialUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailTemplateClonePartialRequest,)
  }
);}


export type postApiEmailTemplateCustomPreviewResponse200 = {
  data: PostApiEmailTemplateCustomPreview200
  status: 200
}

export type postApiEmailTemplateCustomPreviewResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiEmailTemplateCustomPreviewResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiEmailTemplateCustomPreviewResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiEmailTemplateCustomPreviewResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiEmailTemplateCustomPreviewResponseSuccess = (postApiEmailTemplateCustomPreviewResponse200) & {
  headers: Headers;
};
export type postApiEmailTemplateCustomPreviewResponseError = (postApiEmailTemplateCustomPreviewResponse400 | postApiEmailTemplateCustomPreviewResponse401 | postApiEmailTemplateCustomPreviewResponse403 | postApiEmailTemplateCustomPreviewResponse404) & {
  headers: Headers;
};

export type postApiEmailTemplateCustomPreviewResponse = (postApiEmailTemplateCustomPreviewResponseSuccess | postApiEmailTemplateCustomPreviewResponseError)

export const getPostApiEmailTemplateCustomPreviewUrl = () => {


  

  return `/api/email-templates/preview`
}

export const postApiEmailTemplateCustomPreview = async (emailTemplateCustomPreviewRequest: EmailTemplateCustomPreviewRequest, options?: RequestInit): Promise<postApiEmailTemplateCustomPreviewResponse> => {
  
  return customFetch<postApiEmailTemplateCustomPreviewResponse>(getPostApiEmailTemplateCustomPreviewUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailTemplateCustomPreviewRequest,)
  }
);}


export type putApiEmailTemplateEditResponse200 = {
  data: EmailTemplateApiResource
  status: 200
}

export type putApiEmailTemplateEditResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiEmailTemplateEditResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiEmailTemplateEditResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiEmailTemplateEditResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiEmailTemplateEditResponseSuccess = (putApiEmailTemplateEditResponse200) & {
  headers: Headers;
};
export type putApiEmailTemplateEditResponseError = (putApiEmailTemplateEditResponse400 | putApiEmailTemplateEditResponse401 | putApiEmailTemplateEditResponse403 | putApiEmailTemplateEditResponse404) & {
  headers: Headers;
};

export type putApiEmailTemplateEditResponse = (putApiEmailTemplateEditResponseSuccess | putApiEmailTemplateEditResponseError)

export const getPutApiEmailTemplateEditUrl = (id: string,) => {


  

  return `/api/email-templates/${id}`
}

export const putApiEmailTemplateEdit = async (id: string,
    emailTemplateRequest: EmailTemplateRequest, options?: RequestInit): Promise<putApiEmailTemplateEditResponse> => {
  
  return customFetch<putApiEmailTemplateEditResponse>(getPutApiEmailTemplateEditUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailTemplateRequest,)
  }
);}


export type putApiEmailTemplateEditPartialResponse200 = {
  data: EmailTemplateApiResource
  status: 200
}

export type putApiEmailTemplateEditPartialResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiEmailTemplateEditPartialResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiEmailTemplateEditPartialResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiEmailTemplateEditPartialResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiEmailTemplateEditPartialResponseSuccess = (putApiEmailTemplateEditPartialResponse200) & {
  headers: Headers;
};
export type putApiEmailTemplateEditPartialResponseError = (putApiEmailTemplateEditPartialResponse400 | putApiEmailTemplateEditPartialResponse401 | putApiEmailTemplateEditPartialResponse403 | putApiEmailTemplateEditPartialResponse404) & {
  headers: Headers;
};

export type putApiEmailTemplateEditPartialResponse = (putApiEmailTemplateEditPartialResponseSuccess | putApiEmailTemplateEditPartialResponseError)

export const getPutApiEmailTemplateEditPartialUrl = (id: string,) => {


  

  return `/api/email-templates/partials/${id}`
}

export const putApiEmailTemplateEditPartial = async (id: string,
    emailTemplateEditPartialRequest: EmailTemplateEditPartialRequest, options?: RequestInit): Promise<putApiEmailTemplateEditPartialResponse> => {
  
  return customFetch<putApiEmailTemplateEditPartialResponse>(getPutApiEmailTemplateEditPartialUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailTemplateEditPartialRequest,)
  }
);}


export type getApiEmailTemplatePartialSchemaListResponse200 = {
  data: GetApiEmailTemplatePartialSchemaList200
  status: 200
}

export type getApiEmailTemplatePartialSchemaListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiEmailTemplatePartialSchemaListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiEmailTemplatePartialSchemaListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiEmailTemplatePartialSchemaListResponseSuccess = (getApiEmailTemplatePartialSchemaListResponse200) & {
  headers: Headers;
};
export type getApiEmailTemplatePartialSchemaListResponseError = (getApiEmailTemplatePartialSchemaListResponse401 | getApiEmailTemplatePartialSchemaListResponse403 | getApiEmailTemplatePartialSchemaListResponse404) & {
  headers: Headers;
};

export type getApiEmailTemplatePartialSchemaListResponse = (getApiEmailTemplatePartialSchemaListResponseSuccess | getApiEmailTemplatePartialSchemaListResponseError)

export const getGetApiEmailTemplatePartialSchemaListUrl = (name: string,) => {


  

  return `/api/email-templates/partial-schemas/${name}`
}

export const getApiEmailTemplatePartialSchemaList = async (name: string, options?: RequestInit): Promise<getApiEmailTemplatePartialSchemaListResponse> => {
  
  return customFetch<getApiEmailTemplatePartialSchemaListResponse>(getGetApiEmailTemplatePartialSchemaListUrl(name),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiEmailTemplatePreviewResponse200 = {
  data: GetApiEmailTemplatePreview200
  status: 200
}

export type getApiEmailTemplatePreviewResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiEmailTemplatePreviewResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiEmailTemplatePreviewResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiEmailTemplatePreviewResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiEmailTemplatePreviewResponseSuccess = (getApiEmailTemplatePreviewResponse200) & {
  headers: Headers;
};
export type getApiEmailTemplatePreviewResponseError = (getApiEmailTemplatePreviewResponse400 | getApiEmailTemplatePreviewResponse401 | getApiEmailTemplatePreviewResponse403 | getApiEmailTemplatePreviewResponse404) & {
  headers: Headers;
};

export type getApiEmailTemplatePreviewResponse = (getApiEmailTemplatePreviewResponseSuccess | getApiEmailTemplatePreviewResponseError)

export const getGetApiEmailTemplatePreviewUrl = (name: string,) => {


  

  return `/api/email-templates/preview/${name}`
}

export const getApiEmailTemplatePreview = async (name: string, options?: RequestInit): Promise<getApiEmailTemplatePreviewResponse> => {
  
  return customFetch<getApiEmailTemplatePreviewResponse>(getGetApiEmailTemplatePreviewUrl(name),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiEmailTemplateSchemaListResponse200 = {
  data: GetApiEmailTemplateSchemaList200
  status: 200
}

export type getApiEmailTemplateSchemaListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiEmailTemplateSchemaListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiEmailTemplateSchemaListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiEmailTemplateSchemaListResponseSuccess = (getApiEmailTemplateSchemaListResponse200) & {
  headers: Headers;
};
export type getApiEmailTemplateSchemaListResponseError = (getApiEmailTemplateSchemaListResponse401 | getApiEmailTemplateSchemaListResponse403 | getApiEmailTemplateSchemaListResponse404) & {
  headers: Headers;
};

export type getApiEmailTemplateSchemaListResponse = (getApiEmailTemplateSchemaListResponseSuccess | getApiEmailTemplateSchemaListResponseError)

export const getGetApiEmailTemplateSchemaListUrl = (name: string,) => {


  

  return `/api/email-templates/schemas/${name}`
}

export const getApiEmailTemplateSchemaList = async (name: string, options?: RequestInit): Promise<getApiEmailTemplateSchemaListResponse> => {
  
  return customFetch<getApiEmailTemplateSchemaListResponse>(getGetApiEmailTemplateSchemaListUrl(name),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


